<template>
  <div class="percent-prop">
    <div v-for="(it, i) in list" :key="it.attrValue + '_' + i" class="percent-item">
      <el-select v-model="it.attrValue" filterable>
        <el-option v-for="item in propConfig.attrValueList"
          :key="item.id"
          :label="item.name"
          :value="String(item.id)"
          :disabled="disabledOption(item.id)"
        >
        </el-option>
      </el-select>
      <el-input-digit class="input" v-model="it.expand" :precision="3"/> %
      <el-button @click="deleteItem(i)">删除</el-button>
    </div>
    <el-button v-if="list.length < propConfig.attrValueList.length" @click="addItem">添加</el-button>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    propConfig: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemPropValues: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    propConfig: {
      immediate: true,
      handler(propConfig) {
        this.generateList();
      }
    },
    list: {
      deep: true,
      handler(val) {
        this.updateItemPropValues(val);
      }
    },
  },
  methods: {
    // 生成list
    generateList() {
      let { propConfig } = this;
      const defaultValue = {
        attrId: propConfig.id,
        attrValues: [],
        expands: [],
      }
      let propValue = this.itemPropValues.find(it => it.attrId == propConfig.id) || defaultValue;
      propValue = cloneDeep(propValue);
      if (!propValue.expands) {
        propValue.expands = [];
      }
      if (!propValue.units) {
        propValue.units = [];
      }
      let list = propValue.attrValues.map((it, i) => {
        return {
          // attrId: propValue.attrId,
          attrValue: it,
          expand: propValue.expands[i] ?? '',
          unit: propValue.units[i] ?? '%',
        }
      });
      this.list = list;
    },
    disabledOption(id) {
      return this.list.some(it => String(it.attrValue) == String(id));
    },
    // 值更新
    // valueChange(i, field, val) {
    //   this.list[i][field] = val;
    //   this.updateItemPropValues(this.list);
    // },
    // percentInputBlur() {
    //   this.updateItemPropValues(this.list);
    // },
    addItem() {
      const defaultItem = {
        attrValue: '',
        expand: '',
        unit: '%',
      }
      // let list = [
      //   ...this.list,
      //   defaultItem,
      // ];
      // this.updateItemPropValues(list);
      this.list.push(defaultItem);
    },
    deleteItem(i) {
      // const newList = cloneDeep(this.list);
      // newList.splice(i, 1);
      // this.updateItemPropValues(newList);
      this.list.splice(i, 1);
    },
    // 数据组合
    combine(list) {
      let newData = list.reduce((acc, cur) => {
        acc.attrValues.push(cur.attrValue);
        acc.expands.push(cur.expand);
        acc.units.push(cur.unit);
        return acc;
      }, {
        attrValues: [],
        expands: [],
        units: []
      });
      return newData;
    },
    // 更新外部的 itemPropValues
    updateItemPropValues(val) {
      const itemPropValues = cloneDeep(this.itemPropValues);
      let propValue = itemPropValues.find(it => it.attrId == this.propConfig.id);
      if (!propValue) return;
      Object.assign(propValue, this.combine(val));
      Reflect.deleteProperty(propValue, 'attrValueAlias');
      this.$emit('update', itemPropValues);
    },
  },
};
</script>

<style lang="scss" scoped>
.percent-prop {
  .input {
    width: 70px;
    margin-left: 3px;
  }
  .percent-item {
    margin-bottom: 8px;
  }
}
</style>
